/* Thunder Laser USA shop header. Behavior for sections/thunder-header.liquid */
(function () {
  var root = document.getElementById('tls');
  if (!root || root.getAttribute('data-built')) return;
  root.setAttribute('data-built', '1');
  var closeIcon = root.getAttribute('data-close-icon');

  /* Desktop dropdowns: open on hover or click, close on leave, outside click or Escape */
  var items = [].slice.call(root.querySelectorAll('.tls-nav > li.has-panel'));
  function closeAll(except) {
    items.forEach(function (li) {
      if (li !== except) { li.classList.remove('open'); var b = li.querySelector('button'); if (b) b.setAttribute('aria-expanded', 'false'); }
    });
  }
  items.forEach(function (li) {
    var btn = li.querySelector('button'), t;
    function open(via) { clearTimeout(t); closeAll(li); li.classList.add('open'); li.setAttribute('data-via', via); btn.setAttribute('aria-expanded', 'true'); }
    li.addEventListener('mouseenter', function () { if (window.matchMedia('(hover:hover)').matches) open('hover'); });
    li.addEventListener('mouseleave', function () { t = setTimeout(function () { li.classList.remove('open'); btn.setAttribute('aria-expanded', 'false'); }, 150); });
    btn.addEventListener('click', function () { (li.classList.contains('open') && li.getAttribute('data-via') === 'click') ? closeAll() : open('click'); });
  });
  document.addEventListener('click', function (e) { if (!e.target.closest || !e.target.closest('#tls .tls-nav')) closeAll(); });

  /* Search bar (desktop) */
  var sBtn = root.querySelector('.tls-search-btn');
  if (sBtn) sBtn.addEventListener('click', function () {
    var on = !root.classList.contains('search-open');
    root.classList.toggle('search-open', on); sBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
    if (on) { var i = root.querySelector('.tls-searchbar input[type=search]'); if (i) i.focus(); }
  });

  /* Phone menu */
  var burger = root.querySelector('.tls-burger'), drawer = root.querySelector('.tls-drawer'), burgerIcon = burger ? burger.innerHTML : '';
  function sizeDrawer() { var top = root.querySelector('.tls-bar').getBoundingClientRect().bottom; drawer.style.maxHeight = Math.max(200, window.innerHeight - top) + 'px'; }
  function setMenu(on) {
    root.classList.toggle('menu-open', on);
    document.documentElement.style.overflow = on ? 'hidden' : '';
    burger.innerHTML = on ? closeIcon : burgerIcon;
    burger.setAttribute('aria-expanded', on ? 'true' : 'false');
    burger.setAttribute('aria-label', on ? 'Close menu' : 'Open menu');
    if (on) sizeDrawer();
  }
  if (burger) burger.addEventListener('click', function () { setMenu(!root.classList.contains('menu-open')); });
  [].forEach.call(drawer.querySelectorAll('details'), function (d) {
    d.addEventListener('toggle', function () { if (d.open) [].forEach.call(drawer.querySelectorAll('details'), function (x) { if (x !== d) x.open = false; }); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(); root.classList.remove('search-open'); if (root.classList.contains('menu-open')) setMenu(false); } });

  /* Keep the theme's --header-height in sync (other theme parts use it) */
  function setHeight() { var h = root.querySelector('.tls-bar').getBoundingClientRect().bottom - root.getBoundingClientRect().top; document.documentElement.style.setProperty('--header-height', Math.round(h) + 'px'); }
  setHeight();
  window.addEventListener('resize', function () { setHeight(); if (window.innerWidth > 1180 && root.classList.contains('menu-open')) setMenu(false); else if (root.classList.contains('menu-open')) sizeDrawer(); });
  window.addEventListener('scroll', function () { root.classList.toggle('stuck', window.scrollY > 8); }, { passive: true });
})();